import { isEqual } from 'lodash';
import { takeLatest, put, select, delay } from 'redux-saga/effects';

function* watch() {}

export default {
  watch,
};
